import React, { useMemo } from 'react';

import { BuilderComponent } from '@builder.io/react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { BUILDER_MODELS } from '~/builder/constants/models';

import { trackBuilderTest } from '../../utils/builderTesting';
import { useBuilderContent } from '../../utils/useBuilderContent';
import useBuilderJson from '../../utils/useBuilderJson';

const CmsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function CmsStorytelling({ product, builderQueries }) {
  const groupCode = product?.groupCode;
  const dispatch = useDispatch();
  const builderProperties = useMemo(
    () => ({
      modelName: BUILDER_MODELS.PDP_STORYTELLING,
      query: {
        data: {
          storeGroupCode: {
            $in: [{ storeGroupCode: groupCode }, `${groupCode}`],
          },
        },
      },
      builderQueries,
    }),
    [groupCode, builderQueries]
  );

  const { builderJson } = useBuilderJson(builderProperties);
  const { content, locale } = useBuilderContent(builderJson);
  return (
    <CmsContainer>
      {content && (
        <BuilderComponent
          model={BUILDER_MODELS.PDP_STORYTELLING}
          content={content}
          locale={locale}
          contentLoaded={(data, content) => {
            trackBuilderTest(dispatch, content);
          }}
        />
      )}
    </CmsContainer>
  );
}

CmsStorytelling.propTypes = {
  builderQueries: PropTypes.object,
  product: PropTypes.object,
};

export default CmsStorytelling;
